import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useSelector,useDispatch } from 'react-redux'
import {addItemsTabWarnings,deleteItemsTabWarnings} from "../../actions/errorValidationActions";
import { validation } from '../../util/cdsFieldPatterns';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType';

const MerchForm5 = ({ 
  merchandiseId,
  isFormDisabled,
  updateData,
  saveData,
  saveMassRelatedField, 
  invoiceId,
  lineNumber,
  isImportShipment,
  invoiceItemIndex,
  fieldPattern,
  validateError,
}) =>{

  const grossMass=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.grossMass)
  const netMass=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.netMass)
  const quota=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.quota)
  const shippingMarks=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.shippingMarks)
  const cusCode=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.cusCode)
  const undgcode=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.undgcode)|| " "

  const grossMassErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_grossMass`]) 
  const netMassErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_netMass`]) 
  const shippingMarksErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_shippingMarks`]) 
  const undgcodeErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_undgcode`]) 


  const { declarationCat = '' } = useSelector((state) => state.Shipment) || []
  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'itemsTab'),
    [declarationCat]
  )

const {serviceType} = useCurrentShipmentType()

  const dispatch=useDispatch()


  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }

 
  return (
    <Grid.Row>
      <Grid.Column width='3' className='divFormFeild b-rw-0 kg'>
        <InputField
          isLabel={false}
          id={`grossMass-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Gross Mass(kg)'
           boxNumber="6/5"
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          value={grossMass}
          errors={isImportShipment ? 
            getValidationError("grossMass",grossMass):
            grossMassErr && grossMassErr?.msg}
          onChange={(value) =>updateData({grossMass:value})}
          onBlur={(value)=>{saveMassRelatedField({grossMass:grossMass || " "})
          const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_grossMass`
          validateError(
            { [key]: '' },
            { [key]: value },
            { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.grossMass }
          )
          let err = getValidationError('grossMass', grossMass, 'itemsTab')
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `grossMass-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `grossMass-${merchandiseId}`)
        }}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild  kg b-rw-0'>
        <InputField
          isLabel={false}
          id={`netMass-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Net Mass (kg)'
          boxNumber="6/1"
          mandatory={false}
          value={netMass}
          errors={isImportShipment ?
            getValidationError("netMass",netMass||" ") :
            netMassErr && netMassErr?.msg}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) =>updateData({netMass:value})}
          onBlur={(value)=>{saveMassRelatedField({netMass:netMass || " "})

          const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_netMass`
          validateError(
            { [key]: '' },
            { [key]: value },
            { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.netMass }
          )

          let err = getValidationError('netMass', netMass, 'itemsTab')
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `netMass-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `netMass-${merchandiseId}`)
        }}
        />
      </Grid.Column>
      { serviceType === "IM" &&
      <Grid.Column width='3' className='divFormFeild  b-rw-0'>
        <InputField
          isLabel={false}
          id={`quota-${invoiceId}-${merchandiseId}`}
          type='text'
          label="QUOTA"
          boxNumber="8/1"
          disabled={isFormDisabled}
          value={quota}
          className='field-bg'
          clearInput={false}
          onChange={(value) =>updateData({quota:value})}
          onBlur={()=>saveData({quota:quota || " "})}

        />
      </Grid.Column>
      }
      <Grid.Column width='3' className='divFormFeild  b-rw-0'>
        <InputField
          isLabel={false}
          id={`shippingMarks-${invoiceId}-${merchandiseId}`}
          type='text'
          label="Shipping Marks"
          boxNumber="6/11"
          disabled={isFormDisabled}
          className='field-bg'
          clearInput={false}
          value={shippingMarks}
          errors={isImportShipment ? 
            getValidationError("shippingMarks",shippingMarks) : 
            shippingMarksErr && shippingMarksErr?.msg}
          onChange={(value) =>updateData({shippingMarks:value})}
          onBlur={(value)=>{saveData({shippingMarks:shippingMarks || " "})

          const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_shippingMarks`
          validateError(
            { [key]: '' },
            { [key]: value },
            { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.shippingMarks }
          )

          let err = getValidationError('shippingMarks', shippingMarks, 'itemsTab')
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `shippingMarks-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `shippingMarks-${merchandiseId}`)
        }}

        />
      </Grid.Column>
      { serviceType ==="EX" &&
          <Grid.Column width='3' className='divFormFeild  b-rw-0'>
          <InputField
            isLabel={false}
            id={`undgCode-${invoiceId}-${merchandiseId}`}
            type='text'
            label="UN DG CODE"
            boxNumber="6/12"
            disabled={isFormDisabled}
            value={undgcode}
            className='field-bg'
            clearInput={false}
            onChange={(value) =>updateData({undgcode:value})}
            onBlur={(value)=>{
              saveData({undgcode:undgcode || " "})
            }}
  
          />
        </Grid.Column>
      }
      <Grid.Column width='4' className='divFormFeild'>
        <InputField
          isLabel={false}
          id={`cusCode-${invoiceId}-${merchandiseId}`}
          type='text'
          label="Cus Code"
          boxNumber="6/13"
          disabled={isFormDisabled}
          className='field-bg'
          clearInput={false}
          value={cusCode}
          onChange={(value) =>updateData({cusCode:value})}
          onBlur={()=>saveData({cusCode:cusCode || " "})}
        />
      </Grid.Column>
    </Grid.Row>
  )
}
export default React.memo(MerchForm5)
